import { useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useAppState } from 'Context/AppContext/AppContext'
import {
  useInitializeCommunityMutation,
  useCommunityGuidelinesQuery,
} from 'Generated/graphql-types'

const useCommunityRedirection = (spaceSlug?: string) => {
  const { isAuthenticated } = useAuth0()
  const state = useAppState()
  const {
    userConfig: { firstName, lastName },
    nonprofitOrgConfig: { orgName },
  } = state
  const name = `${firstName} ${lastName}`

  const [communityRedirectionUrl, setCommunityRedirectionUrl] =
    useState<string>('/community')

  const [initializeCommunity] = useInitializeCommunityMutation()

  useCommunityGuidelinesQuery({
    onCompleted: async (guidelinesData) => {
      if (guidelinesData?.communityGuidelines?.isAgreed) {
        try {
          const { data } = await initializeCommunity({
            variables: {
              agreedCommunityGuidelines: true,
              name,
              ...(spaceSlug && { spaceSlug }),
              ...(orgName && { orgName }),
            },
          })

          if (data?.initializeCommunity?.communityURL) {
            setCommunityRedirectionUrl(
              data?.initializeCommunity?.communityURL.toString()
            )
          }
        } catch (error) {
          console.log('UseCommunityRedirection: Mutation fails ')
          console.log(error)
        }
      }
    },
    fetchPolicy: 'network-only',
    skip: !isAuthenticated,
    context: { clientName: 'batched' },
  })

  return {
    communityRedirectionUrl,
  }
}

export default useCommunityRedirection
